import { PlaceTypeEnum } from '../enums/PlaceTypeEnum';

export interface Plan {
  id: number;
  type: string;
  name: string;
  description: string;
  benefits: string[];
  value: string;
  minValue?: number;
  placeType: PlaceTypeEnum;
}

export const plans: Plan[] = [
  {
    id: 5,
    name: 'Plano SEM COMPROMISSO ',
    type: 'FREE',
    description: `<p>Cadastro e manutenção do seu espaço 100% grátis – sem mensalidade, sem taxa de adesão. Você recebe notificações com informações básicas do evento interessado (tipo de evento, data e número de convidados) sempre que seu espaço for filtrado na busca de um organizador.</p>
  <p>Para manifestar interesse e receber os dados completos do evento e do organizador, você paga apenas R$ 24,90 por demonstração expressa de interesse e fica liberado para interagir com o organizador. Se não houver demonstração interesse, não há nenhum custo para o espaço.</p>
  <p>Publique seu espaço entre os melhores, sem compromisso real: teste, receba oportunidades de negócios e pague só quando quiser prosseguir.</p>`,
    benefits: [
      '• Home page exclusiva e editável para seu espaço',
      '• Simples, transparente e sem risco',
      '• Zero custo para cadastrar e manter a home page de seu espaço',
      '• Você só paga por leads que você mesmo escolheu como interessantes',
      '• Sem mensalidade, sem compromisso fixo',
      '• Total controle: responde apenas aos eventos que fazem sentido para você',
      '• Aplicação e exibição de logomarca',
      '• Descrição do espaço',
      '• Informação da capacidade mínima e máxima',
      '• Informações das caracteristicas do Espaço',
      '• Tipo de Espaço',
      '• Tipos de eventos que seu espaço comporta',
    ],
    value: 'Gratuito',
    placeType: PlaceTypeEnum.FREE,
  },
  {
    id: 4,
    name: 'Plano PRÉ-PAGO',
    type: 'PREPAID',
    description: `<p>Você faz aportes de créditos inicial no valor mínimo de R$ 99,90 (ou qualquer quantia acima disso).</p>
  <p>Paga apenas R$ 19,90 por demonstração de interesse quando tem saldo disponível – preço mais baixo que o Plano Sem Compromisso, em torno de 20% a menor.</p>
  <p>Recebe notificações com informações básicas sempre que seu espaço for filtrado por busca de um organizador. Se não tiver saldo suficiente, não poderá demonstrando interesse, interagir com o evento nem obter as informações completas do organizador.</p>
  <p>Créditos válidos por 12 meses, sem renovação automática. Publique seu espaço entre os melhores com controle total e economia: invista só o que precisar e pague menos pelos leads que escolher.</p>`,
    benefits: [
      '• Home page exclusiva e editável para seu espaço',
      '• Simples, econômico, flexível e sem riscos',
      '• Custo abatido de seu crédito, apenas quando você demonstra interesse em um evento filtrado',
      '• Você escolhe o valor do aporte (mínimo R$ 99,90, qualquer quantia acima)',
      '• Créditos válidos por 12 meses, sem mensalidade ou renovação automática',
      '• Valor deduzido de R$ 19,90 por lead sempre que houver interesse e saldo disponível',
      '• Aplicação de logomarca',
      '• Aplicação da foto principal',
      '• Descrição do espaço',
      '• Informação da capacidade mínima e máxima',
      '• Informações das caracteristicas do espaço',
      '• Tipo de espaço',
      '• Tipos de eventos que seu espaço comporta',
      '• Pasta para até 10 imagens de seu espaço ou eventos realizados',
      '• Google Maps com a localização de seu espaço',
    ],
    value: 'R$ 99,90',
    minValue: 99.9,
    placeType: PlaceTypeEnum.PARTNER,
  },
];
